import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import "../../styles/custom-tabview.css";
import axios from "axios";
import Stock from "./stock";
import Dem from "./dem";
import Relance from "./relance";
import HeaderMail from "./headerMail";
const apiUrl = process.env.REACT_APP_API_URL;

const TABS = [
  { label: "Stockage", key: "stock" },
  { label: "Déménagement", key: "dem" },
  { label: "Relance", key: "relance" },
];

export default function Mail() {
  const [activeIndex, setActiveIndex] = useState(() => {
    const storedIndex = localStorage.getItem("activeTabIndexMail");
    return storedIndex !== null ? parseInt(storedIndex, 10) : 0;
  });

  const handleTabChange = (index) => {
    setActiveIndex(index);
    localStorage.setItem("activeTabIndexMail", index);
  };

  const [counters, setCounters] = useState({
    stock: 0,
    dem: 0
  });

 useEffect(() => {
    axios.get(`${apiUrl}/IHM/api/mails/mails.php?pannel=true`)
      .then(res => setCounters(res.data))
      .catch(err => console.error("Erreur compteurs:", err));
  }, [activeIndex]);


  return (
    <div>
      <HeaderMail />

      <div
        style={{
          overflowX: "auto",
          overflowY: "visible",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="flex flex-column md:flex-row justify-content-between md:align-items-center p-2 gap-3">
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "4px",
                minWidth: "max-content",
              }}
            >
              {TABS.map((tab, i) => {
                const isActive = i === activeIndex;
                return (
                  <div
                    key={i}
                    onClick={() => handleTabChange(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 12px",
                      height: "35px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      flexShrink: 0,
                      backgroundColor: isActive ? "#0971b7" : "transparent",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      userSelect: "none",
                    }}
                  >
                    <span
                      style={{
                        color: isActive ? "#fff" : "#6b6b6b",
                        fontWeight: isActive ? 700 : 500,
                        fontSize: "13px",
                      }}
                    >
                      {tab.label}
                    </span>

                    <span
                      style={{
                        marginLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        fontWeight: "bold",
                        fontSize: "10px",
                        width: "18px",
                        height: "18px",
                        backgroundColor: isActive ? "#F8F9FA" : "transparent",
                        color: isActive ? "#0A2540" : "#9a9a98",
                      }}
                    >
                      {counters[tab.key] ?? 0}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div style={{ padding: "1rem 0 0 0" }}>
          {activeIndex === 0 && <Stock />}
          {activeIndex === 1 && <Dem />}
          {activeIndex === 2 && <Relance />}
        </div>
      </div>
    </div>
  );
}